module.exports = __webpack_public_path__ + "img/hope_square.edbd856c.jpg";